import theme from 'tailwindcss/defaultTheme';

const breakpoints = theme.screens;

export { breakpoints };
